import { render, staticRenderFns } from "./FeatureConfig.vue?vue&type=template&id=1817ff7c&scoped=true&"
import script from "./FeatureConfig.vue?vue&type=script&lang=js&"
export * from "./FeatureConfig.vue?vue&type=script&lang=js&"
import style0 from "./FeatureConfig.vue?vue&type=style&index=0&id=1817ff7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1817ff7c",
  null
  
)

export default component.exports